import { on, createEffect } from 'solid-js';
import usePresenter from '~/framework/hooks/usePresenter';
import { TenantInfoPresenter } from '~/presenters/TenantInfoPresenter';

export const Cobrowse = () => {
  const { model: tenantInfo } = usePresenter(TenantInfoPresenter);

  createEffect(
    on(
      () => tenantInfo()?.id,
      () => {
        if (!tenantInfo()?.id) return;

        // Generate or retrieve device ID
        let deviceId = localStorage.getItem('device_id');
        if (!deviceId) {
          deviceId = crypto.randomUUID();
          localStorage.setItem('device_id', deviceId);
        }

        window.CobrowseIO.customData = {
          user_id: tenantInfo()?.id,
          user_name: tenantInfo()?.name,
          user_email: tenantInfo()?.email,
          device_id: deviceId,
          device_name: 'Tenant - ' + tenantInfo()?.id + ' - ' + tenantInfo()?.name + ' - ' + tenantInfo()?.email,
        };
      }
    )
  );

  return null;
};
